import { useLocation } from '@remix-run/react'
import { useMemo } from 'react'
import { aOrganization, aUser, useAtomValue } from '~/atoms'
import type { Listing } from '~/models'
import Detail from './Detail'
import OffMarket from './OffMarket'

type ListingDetailLayoutProps = {
  canEdit: boolean
  listing: Listing
}

export default function ListingDetailLayout({
  canEdit,
  listing,
}: ListingDetailLayoutProps) {
  const organization = useAtomValue(aOrganization)
  const user = useAtomValue(aUser)
  const location = useLocation()

  const showBrokers = useMemo(() => {
    return (
      location.search.includes('brokers=true') ||
      !location.search.includes('report')
    )
  }, [location])

  return (
    <>
      {user || listing.status === 'active' || listing.status === 'pending' ? (
        <Detail
          user={user}
          listing={listing}
          organization={organization!}
          canEdit={canEdit}
          location={location}
          showBrokers={showBrokers}
        />
      ) : (
        <OffMarket
          listing={listing}
          organization={organization!}
          canEdit={canEdit}
          showBrokers={showBrokers}
        />
      )}
    </>
  )
}
